export default angular
  .module('app.conf', [])
  .name;

require('./constants/config');
require(`./constants/environment-${process.env.APP_ENV}`);



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/conf/index.js